export const VenueFragment = /* GraphQL */ `
	fragment VenueFragment on Venue {
		_id
		created_at
		updated_at
		name
		description
		address
		timezone
		logo
		banner_img
		is_self_served
		allow_comments
		item_types
		cancelled_reason_options
		custom_payment_types {
			label
			value
			is_deactivated
		}
		shifts {
			title
			startTime
			endTime
		}
		auto_print_checklist
		currencies_configs {
			code
			rate
			previous_rate
			is_primary_currency
			is_secondary_currency
			is_deactivated
		}
		fcm_tokens
		is_service_charge_buried
		service_charge
		service_charge_bd
		is_service_charge_bd_buried
		is_vat_buried
		vat
		theme {
			primary_color
			primary_text_color
		}
		is_digital_menu_user_login_enabled
		is_digital_menu_user_sign_up_enabled
		is_ordering_requires_customer
		is_qr_ordering_only
		default_service_charge_type
		custom_note_instructions
		is_ordering_requires_note
		order_notification_dings
		is_payway_integration_enabled
		is_internal_receipt_enabled
		is_language_localization_enabled
		is_digital_menu_additional_language_enabled
		additional_digital_menu_languages
		is_required_headcount_before_payment
		is_payment_confirmation_enabled
		is_payment_rounding_enabled
		user_limit
		tax
	}
`;
